import {
  Button,
  Dialog,
  Flexbox,
  Spacer,
  useToast,
} from "@skf-internal/ui-components-react";
import * as React from "react";
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";

import { useNavigate } from "react-router-dom";
import {
  ISearchUser,
  resetSearch
} from "../group-users/groupUserSlice";
import { IApplication } from "../applications/Applications";
import { addAdminToApplication } from "./applicationDetailsAPI";
import UserSearchBox from "../common/userSearchBox";

export interface IAddAdminProps {
  auth: any;
  application: IApplication;
  callBack:any;
  reRender:any;
}

export default function AddAdmin(props: IAddAdminProps) {
  const { auth, application, callBack, reRender } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [disable, setDisable] = useState(false);
  const [showField, setShowField] = useState(true);

  const [displaySearchedUser, setDisplaySearchedUser] = useState("");
  const [infoMessage, setInfoMessage] = useState("");

  const [selectedUsers, setSelectedUsers] = useState<ISearchUser[]>([]);
  const [searchUser, setSearchUser] = useState<any[]>([]);
  const { addToast } = useToast();


  const create = () => {
    if (searchUser.length > 0) {
      let result: string = "";
      searchUser.forEach((user: ISearchUser) => {
        addAdminToApplication(application.applicationId, user.id)
          .then((res) => {
            setInfoMessage("User(s) successfully created!");
            dispatch(resetSearch([]));
            addToast({
              children: "User added as admin",
              feSeverity: "success",
            });
          })
          .catch((error) => {
            if (error.response) {
              setInfoMessage(error.response.data);
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
              addToast({
                children: "Something went wrong " + error.response.data,
                feSeverity: "error",
              });
            }
          });
      });
      setTimeout(() => {
        setIsOpen(false);
        setInfoMessage("");
        callBack();
        reRender(true);
        reRender(false);
      }, 1000);
    } else {
      setInfoMessage("select user first");
      console.log("select user first");
    }
  };

  useEffect(() => {
    setDisplaySearchedUser("");
    setEmail("");
    setSelectedUsers([]);
    setInfoMessage("");
    setDisable(true);
    setShowField(true);
  }, [isOpen]);

  useEffect(() => {
  }, [searchUser]);


  const isSkfUser = () => {
    if (searchUser?.length > 0) {
      return (!(searchUser[0]?.email?.endsWith("@skf.com")))
    }
  }

  return (
    <div>
      <Button onClick={() => setIsOpen(true)}>Add user</Button>
      <Dialog
        {...props}
        feInterruptive
        feTitle="Add new application administrator"
        open={isOpen}
        cssWidth={"54rem"}
        cssHeight={"36rem"}
      >
        <div className="assignDialog">
          <span>
          You are adding a new application administrator for application  <b>{application.applicationName}</b>
            <br />
          </span>
          {infoMessage !== "" && (
            <>
              <h6>{infoMessage}</h6>
              <Spacer />
            </>
          )}
          <p>
            <UserSearchBox setSelectedUser={setSearchUser} skfUsersOnly={true} />
          </p>

          <Spacer feSpacing="md" />
          <Spacer feSpacing="md" />
          <Flexbox
            feGap="md"
            feJustifyContent="flex-end"
            className="modalButtons"
          >
            <Button feType="secondary" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button
              onClick={() => create()}
              disabled={
                searchUser === null ||
                searchUser.length !== 1 ||
                isSkfUser()
              }
            >
              Confirm
            </Button>
          </Flexbox>
        </div>
      </Dialog>
    </div>
  );
}
